import { useTranslation } from 'react-i18next';
import { Button, Modal } from '../components/ui';

/** Übersicht aller Editor-Tastenkürzel (geöffnet via „?" oder Toolbar-Knopf). */
export function ShortcutHelpModal({ open, onClose }: { open: boolean; onClose: () => void }) {
  const { t } = useTranslation();
  const mod = t('editor.sc.mod');
  const shift = t('editor.sc.shift');

  const rows: [string, string][] = [
    [`${mod}+Z`, t('editor.sc.undo')],
    [`${mod}+Y`, t('editor.sc.redo')],
    [`${mod}+S`, t('editor.sc.save')],
    [`${mod}+D`, t('editor.sc.duplicate')],
    [t('editor.sc.del'), t('editor.sc.delete')],
    [`${mod}+G`, t('editor.sc.group')],
    [`${mod}+${shift}+G`, t('editor.sc.ungroup')],
    [`${mod}+[ / ${mod}+]`, t('editor.sc.layerStep')],
    [`${mod}+${shift}+[ / ${mod}+${shift}+]`, t('editor.sc.layerEnds')],
    [`${shift}+${t('editor.sc.click')}`, t('editor.sc.multiSelect')],
    [t('editor.sc.mouseLeftKeys'), t('editor.sc.mouseLeft')],
    [t('editor.sc.mouseRightKeys'), t('editor.sc.mouseRight')],
    ['Esc', t('editor.sc.clear')],
    ['+ / −', t('editor.sc.zoom')],
    [t('editor.sc.spaceOrMiddle'), t('editor.sc.pan')],
    ['?', t('editor.sc.help')],
  ];

  return (
    <Modal open={open} title={t('editor.sc.title')} onClose={onClose}>
      <table className="w-full text-sm">
        <tbody>
          {rows.map(([keys, label]) => (
            <tr key={keys} className="border-b border-slate-100 last:border-0 dark:border-slate-700/60">
              <td className="py-1.5 pr-3">
                <kbd className="rounded bg-slate-100 px-1.5 py-0.5 font-mono text-xs dark:bg-slate-700">{keys}</kbd>
              </td>
              <td className="py-1.5 text-slate-600 dark:text-slate-300">{label}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="mt-4 flex justify-end">
        <Button variant="secondary" onClick={onClose}>
          {t('common.close')}
        </Button>
      </div>
    </Modal>
  );
}
